import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(({ palette, breakpoints, typography }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 300,
    textAlign: 'center',
    background: 'url(./free-trial/free-trial-background-mobile.svg)',
    backgroundRepeat: 'no-repeat',
    color: palette.primary.contrastText,
    backgroundPosition: 'center',
    backgroundSize: '100%',
    [breakpoints.up('sm')]: {
      background: 'url(./free-trial/free-trial-background-desktop.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: 332,
    },
  },
  background: {
    background: 'url(./free-trial/free-trial-background-mobile.svg)',
  },

  descriptionText: {
    maxWidth: 285,
    ...typography.subtitle1,
    [breakpoints.up('sm')]: {
      ...typography.h6,
    },
  },
}));

export const FreeTrial = () => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.background} />
      <Typography variant="h5">Start Safe!</Typography>
      <Box mt={4} />
      <Typography className={classes.descriptionText}>
        Get 7 days FREE trial with your new personal trainer
      </Typography>
      <Box mt={{ md: 4 }} />
    </Box>
  );
};
